import { useState } from 'react';
import { Grid2 as Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SelectionButton } from '../../../component/buttons';
import { CommonCard } from '../../../component/cards/MainCard2';
import { EditButton } from '../../../component/buttons';
import { useRole } from '../../../utils/RoleContext';
import UsersGrid from './UsersGrid';

const Users = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { role } = useRole();
    const [selected, setSelected] = useState(0);

    const sections = [t('users.sections.patients'), t('users.sections.doctors')];
    const types = ['PATIENT', 'DOCTOR'];

    if (role === 'CLINIC_ADMIN') {
        sections.push(t('users.sections.administrators'));
        types.push('CLINIC_ADMIN');
    }

    return (
        <CommonCard sx={{ m: 2, p: 2 }}>
            <Grid container spacing={{ xs: 3, md: 4 }}>
                {sections.map((value, index) => (
                    <Grid key={index} size={{ xs: 4 }}>
                        <SelectionButton
                            selected={selected === index}
                            sx={{ width: '100%', py: 2 }}
                            onClick={() => setSelected(index)}
                        >
                            {value}
                        </SelectionButton>
                    </Grid>
                ))}

                <Grid container size={12} justifyContent="flex-end">
                    <EditButton
                        onClick={() =>
                            navigate('/users/add', {
                                state: { preselectedType: types[selected] }
                            })
                        }
                    >
                        <Typography variant="subtitle2">
                            {t('users.addNewUser')}
                        </Typography>
                    </EditButton>
                </Grid>

                <Grid size={12}>
                    <UsersGrid types={[types[selected]]} typeName={sections[selected]} />
                </Grid>

                {/**{types[selected] === 'PATIENT' && (
                    <Grid size={12}>
                        <UsersGrid
                            types={['PATIENT_CARE_GIVER']}
                            typeName="Auxiliares de Pacientes"
                        />
                    </Grid>
                )}

                {types[selected] === 'DOCTOR' && (
                    <Grid size={12}>
                        <UsersGrid
                            types={['CLINIC_CARE_GIVER']}
                            typeName="Auxiliares Clínicos"
                        />
                    </Grid>
                )}**/}
            </Grid>
        </CommonCard>
    );
};

export default Users;
